import { QueryClient } from '@tanstack/react-query';
import { QUERY_CLIENT_OPTIONS } from './queryClientOptions';

export const QUERY_CLIENT = new QueryClient(QUERY_CLIENT_OPTIONS);
